import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import './styles/App.css';

const App: React.FC = () => {
  const basename = process.env.PUBLIC_URL || undefined;

  return (
    <BrowserRouter basename={basename}>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;
